<template>
  <div class="bg-white shadow-md w-full subheader px-4" ref="wrapper">
    <ul
      @scroll="handleHorizontalScroll"
      class="
        text-STorange
        font-OswaldFont
        max-w-6xl
        md:w-10/12 
        sm:w-11/12
        mx-auto
        lg:text-2xl
        md:text-xl
        sm:text-lg
        text-lg
        w-full
        overflow-x-auto
        overflow-y-hidden
        whitespace-nowrap
      "
      ref="itemContainer"
    >
      <li @click="scroll('press-releases')">PRESS RELEASE</li>
      <li @click="scroll('articles')">ARTICLES</li>
      <li @click="scroll('videos')">VIDEOS</li>
      <li @click="scroll('images')">IMAGES</li>
      <li @click="scroll('headshots')">HEADSHOTS &amp; LOGOS</li>
      <li @click="scroll('contact')">CONTACT</li>
    </ul>

    <div class="arrows ">
      <img
        :src="getLeftArrow()"
        alt="left-arrow"
        @click="scrollDirection('right')"
        class="left-0 arrow"
        :class="hideLeftArrow ? 'hidden' : null"
      />

      <img
        :src="getRightArrow()"
        alt="right-arrow"
        @click="scrollDirection('left')"
        class="right-0 arrow"
        :class="hideRightArrow ? 'hidden' : null"
      />
    </div>
  </div>
</template>

<script>
import { generateFullPath } from "../../utils/fileHelpers";
import { determineArrows } from "../../utils/arrowHelper";

export default {
  name: "MediaSubheader",

  data() {
    return {
      arrowMargin: 20,
      hideRightArrow: false,
      hideLeftArrow: true,
    };
  },

  computed: {
    wrapperSize() {
      return this.$refs.wrapper.clientWidth;
    },

    subheaderSize() {
      let totalWidth = 0;
      this.$refs.itemContainer.children.forEach(
        (e) => (totalWidth += e.clientWidth),
      );

      return totalWidth;
    },

    subheaderInvisibleSize() {
      return this.subheaderSize - this.wrapperSize;
    },
  },

  methods: {
    scroll(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      });
    },

    subheaderPosition() {
      return this.$refs.itemContainer.scrollLeft;
    },

    handleHorizontalScroll() {
      const subheaderPosition = this.subheaderPosition();
      const offset = this.subheaderInvisibleSize - this.arrowMargin;

      const { leftArrow, rightArrow } = determineArrows(
        subheaderPosition,
        this.arrowMargin,
        offset,
      );

      this.hideLeftArrow = leftArrow;
      this.hideRightArrow = rightArrow;
    },

    scrollDirection(dir) {
      const scrollNum = dir === "left" ? this.subheaderSize : 0;

      this.$refs.itemContainer.scrollTo({
        left: scrollNum,
        behavior: "smooth",
      });
    },

    getRightArrow() {
      return generateFullPath("/themes/st2018/img/tile-arrow-right.png");
    },

    getLeftArrow() {
      return generateFullPath("/themes/st2018/img/tile-arrow-left.png");
    },
  },
};
</script>

<style lang="scss" scoped>
.subheader {
  position: sticky;
  top: 85px;
  z-index: 50;

  @media screen and (max-width: 1280px) {
    top: 135px;
  }

  @media screen and (max-width: 1200px) {
    top: 70px;
  }

  @media screen and (max-width: 1025px) {
    top: 118px;
  }

  @media screen and (max-width: 770px) {
    top: 70px;
  }

  li {
    cursor: pointer;
    padding: 20px 15px;
    display: inline-block;

    ::hover {
      background-color: #f0f0f0;
    }

    @media screen and (max-width: 768px) {
      padding: 20px 10px;
    }

    a {
      text-transform: uppercase;
    }
  }

  .arrows {
    display: none;

    @media (max-width: 600px) {
      display: block;
    }

    .arrow {
      position: absolute;
      top: 0;
      bottom: 0;
      height: 1.5rem;
      width: 1.5rem;
      margin: auto 0;
      cursor: pointer;
    }

    .hidden {
      display: none;
    }
  }
}
</style>
